/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { withAuth } from '@project/components';
import { RootContext } from '../../hoc/RootContext/RootContext';
import axios from "../../utils/axios";

const LOGIN_URL = `${process.env.REACT_APP_IDCLOUD_HOST}?app=id360&path=/admin/profile/new`;

const PrivateRoute = ({ children, ...routeProps }) => {

  const {
    authToken,
    setAuthToken,
    currentUser,
    setCurrentUser
  } = useContext(RootContext);

  // only do user lookup for private pages
  const getUser = async () => {
    try {

      const result = await axios.post('/login', { token: authToken });

      if (result.status === 200) {
        const { user } = result.data;

        if (!user.is_id360_admin && !user.is_id360_user) {
          // user will get redirected back to id cloud login
          setAuthToken(null);
          setCurrentUser(null);
        }
        else {
          setCurrentUser(user);
        }
      }

    } catch (e) {
      setAuthToken(null);
      setCurrentUser(null);
    }
  };

  useEffect(() => {
    if (authToken && !currentUser) {
      getUser();
    }
  }, [authToken, currentUser]);

  return children;
};

export default withAuth(PrivateRoute, {
  kickToExternalUrl: LOGIN_URL
});
